import {DOWNLOAD_CONSULTANT_FIELD_IMAGE,
  FETCH_CONSULTANT,
  FETCH_CONSULTANTS,
  FETCH_CONSULTANTS_INFOS,
  FETCH_CONSULTANT_LIST,
  FETCH_CONSULTANT_TEAM,
  CREATE_CONSULTANT,
  UPDATE_CONSULTANT,
  UPDATE_CONSULTANT_PICTURE,
  DELETE_CONSULTANT,
  SET_INITIAL_STATE_CONSULTANT,
  CONSULTANT_ERROR,
  EXPORT_CONSULTANT,
  EXPORT_CONSULTANTS_LIST,
  SET_STAR_IS_LOADING
} from '../actions/types';

const INITIAL_STATE = {
  consultant: {},
  consultants: [],
  consultantsInfos: {},
  message: '',
  list: {},
  error: '',
  starIsLoading: false
};

export default function(state = INITIAL_STATE, action) {
  var consultant;
  switch (action.type) {
    case SET_STAR_IS_LOADING:
      return { ...state,
        starIsLoading: action.payload
      };
    case FETCH_CONSULTANTS_INFOS:
        return { ...state,
          consultantsInfos: action.payload,
          message: '',
          error: '',
        };
    case FETCH_CONSULTANTS:
      return { ...state,
        consultants: action.payload.documents,
        message: '',
        error: '',
        starIsLoading: false
      };
    case FETCH_CONSULTANT:
      return { ...state,
        consultant: action.payload.document,
        message: '',
        error: ''
      };
    case FETCH_CONSULTANT_LIST:
      return { ...state,
        list: action.payload.list,
        message: '',
        error: ''
      };
    case FETCH_CONSULTANT_TEAM:
      return { ...state,
        consultants: action.payload.documents,
        message: action.payload.message,
        error: ''
      };
    case EXPORT_CONSULTANTS_LIST:
      return { ...state, export: action.payload, message: '', error: '' };
    case EXPORT_CONSULTANT:
      return { ...state, export: action.payload, message: '', error: '' };
    case CREATE_CONSULTANT:
      return { ...state,
        message: action.payload.message,
        error: ''
      };
    case UPDATE_CONSULTANT:
      consultant = Object.assign({}, action.payload.document);
      return { ...state,
        consultant: consultant,
        message: action.payload.message,
        error: ''
      };
    case UPDATE_CONSULTANT_PICTURE:
      consultant = Object.assign({}, action.payload.document);
      return { ...state,
        consultant: consultant,
        message: action.payload.message,
        error: ''
      };
    case DELETE_CONSULTANT:
      return { ...state,
        message: action.payload.message,
        error: ''
      };
    case DOWNLOAD_CONSULTANT_FIELD_IMAGE:
      return { ...state, export: action.payload, message: '', error: '' };
    case CONSULTANT_ERROR:
      return { ...state,
        error: action.payload
      };
    case SET_INITIAL_STATE_CONSULTANT:
      return {
        consultant: {},
        consultants: [],
        consultantsInfos: {},
        message: '',
        list: {},
        error: ''
      };
    default:
      return { ...state
      }
  }

  //return state;
}
